module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('h1', {
    staticClass: "calibre34",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('a', {
    staticClass: "calibre35",
    attrs: {
      "id": "_Toc81914609"
    }
  }), _c('a', {
    staticClass: "calibre35",
    attrs: {
      "id": "_Toc81914979"
    }
  }, [_c('span', {
    staticClass: "calibre36"
  }, [_vm._v("The end. No, seriously, this is the end.")]), _c('span', {
    staticClass: "calibre37"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_c('span', {
    staticClass: "calibre38"
  }, [_vm._v("I")]), _vm._v(" "), _c('span', {
    staticClass: "calibre11"
  }, [_vm._v("t only makes sense to start at the end because beginnings lead to it, anyway. So, I’ll give you what you’re looking for right up front.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("It is a clear, starless black night. A cold breeze sets in, making the hair on my skin stand. My frizzy curls dance, smacking my face every thirty seconds. I keep my hands still, placed on my lap. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("I deserved to be slapped across the face")]), _c('span', {
    staticClass: "calibre11"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("My eyes water with the sting of the crisp night air. The bottom sides of the bucket I sit on top of dig into the back of my thighs, leaving marks deep and blood red. I stay seated on top of that bucket for hours, feeling lethargic and finally being able to catch my breath. The deeper it digs into my backside, the more numb I feel. I let it do its job. I let it stab me so hard that it numbs all of me from the inside out. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("Finally.")]), _c('span', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("When the numbness consumes me, I reject it. I stand and kick the bucket across the field, hard. I let out a scream I know no one can hear. Dropping down on the cold wet grass, I feel it ease up the indentions on the back of my bare legs. I inhale a big gasp and hold it in as I swing my body to fall flat onto the ground, letting the earth become my bed to cry on. The tears well from deep inside and course down my cheeks. I let out a moan and howl that would haunt a mother’s nightmares with the thought of her daughter needing her; shattering every bit of her broken heart. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("My baby cried for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("I yank out my “luscious locks” everyone just loves so much and pinch my arms black and blue until I become lethargic once more. I curl into a ball, hugging myself I suppose to comfort, not that I deserve that because I am a murderer. I did kill someone. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("People who take another person’s life just don’t deserve to be patted on the back afterwards. No. I don’t deserve this hug. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("You made your bed, now lie in it, ")]), _c('span', {
    staticClass: "calibre11"
  }, [_vm._v("my mother would say. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("And so, I do. I stay right there on the cold and wet ground all night and even for a few days after, not even caring that I hadn’t eaten a bite of food or had a drop of water touch my tongue. My mouth is dry and cracking and peeling. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("Someone out there does care, though. My body is stumbled upon, and I can just faintly hear a man and a woman talking to each other. Their voices get closer and closer to me. They think I’m a victim of some brutal attack with the bruises from my pinching tattooed into sleeves on my arms, my hair is matted and mangled with leaves making their home in between the tresses. My black floral sundress is smeared of mud and grass stains and blood. My dirty bare feet show, and my shoes are nowhere to be found. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("The couple feels sorry for me, as any normal person should. They each grab a hold of me and hoist my dead weight of a body up off the ground. They walk me to their car. They’re talking to me, but I can’t make out what they say. The day is too loud and bright. When we get to their car, they gently lay my frail body in the back seat. I smell cleanliness and a cheap car freshener in the air. The stains I’ll leave behind on their pearl white seats will tell a sad story indeed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("“What’s your name?” the woman asks. But I don’t answer her. I’m not trying to be rebellious against them, like a child who refuses to answer their parents or teachers questions. I stay quiet, though. I’m just freezing and starving and weak.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("  “Can you hear me?” she tries again.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("“Willow” I whisper and my throat hurts. It feels and tastes like blood back there.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("“Willow. That’s a pretty name. Can you tell me who did this to you, Willow?” Her voice sounds like a teacher’s does when they’re getting down to the bottom of who started it on the playground.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("Me. I did this. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("But again, I say nothing. And this time I really say nothing. I press and hold my lips together, close my eyes and fall asleep because that’s all my weak body can do.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("I’m awakened by a needle piercing into a vein in my arm. I lay there lifeless, letting the doctors and nurses poke and prod at me however they like. They sedate me with enough morphine to kill off all the physical and mental pain I feel. I’m loopy-headed and feeling pretty damn good as I sing out loud Ironic, by Alanis Morissete. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("My off-tune singing continues while they roll me from triage to the recovery room. I’m having the time of my life, and I as I look up, I’m met with a few faces covered in hospital masks peering down at me. The wrinkles that surround their eyes show me they’re smiling at me. They think I’m funny. I think they like the way I sing. Those faces are the last of what I see before falling back asleep. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("When I wake up, I notice fresh flowers on the window seal of the room I’m recovering in. The couple who saved my life are gone, but they left me a card and a balloon with get well soon in bright colors marked on both. The bouquet is from all the staff. It’s not a cheap one, either. The assortment is beautifully put together. Those dainty multi-colored flowers have already blossomed and bloomed. I open the card from the couple and read the note they left for me. It was just a simple little quote on the inside, and they wrote that they’ll be back to check on me. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("They signed it with ")]), _c('span', {
    staticClass: "calibre10"
  }, [_vm._v("Mr. & Mrs. Grey")]), _c('span', {
    staticClass: "calibre11"
  }, [_vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("A petite, bubbly nurse walks in with a plate of hospital food balanced on a tray and when she sets it in front of me, I devour it all within minutes, starting with the Jell-O. The red, strawberry kind. My favorite. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("She stays to witness the starved prisoner finally getting to eat, and I feel awkward scarfing my food down in front of her. Every single crumb vanishes off the plate as she stands there to watch me eat. I eyeball her a few times, hoping she doesn’t take it away before I can finish it. She smiles and tells me there’s more where that came from, before walking back into the hospital halls to a few nurses that peer into the room I lay in. They whisper to each other as they walk away. I don’t hear what they’re saying, but I can only imagine.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("I know what they’re all thinking; I’m a victim of some psychosexual predator and he’s out on the loose, stalking his next prey. The next beautiful innocent young woman who’s just headed home from the pub or library or grocery store will be unfortunate. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("Boy, are they ever so wrong! ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("I’m a cold-blooded killer, but I’m not ready to admit such a thing just yet, because now that I’m thinking clearly, I remember why I did it. But I wonder… ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre21"
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("How many lives do you have to take before you’re labeled a serial killer?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre39"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e39a1e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0004_split_001.vue
// module id = 75
// module chunks = 0